<script lang="js">
import Vue from 'vue'
import serverService from '../../service/api/serverService'
import ConnectionSelect from "@/components/packet/ConnectionSelect.vue";
import packetService from '../../service/api/packetService';

export default Vue.extend({
  name: "PacketConnectionEditor",
  components: {ConnectionSelect},
  props: {
    packet: {
      type: Object
    },
  },
  data() {
    return {
      opened: false,
      items: [],
      current: '1',
      maxConnections: -1,
      loading: false
    }
  },
  created() {
    this.loadConnectionList()
    this.current = this.packet.filter.id
  },
  computed: {
    price () {
      if (!this.current ) return 0.00
      const curr = this.items.find(connection => connection.id === this.current)
      if (!curr) {
        return 0.00
      }

      const selected = this.packet.filter
      if (curr.id === selected.id) {
        return 0.00
      }
      return selected.iptvSurcharge - curr.iptvSurcharge
    },
    notChanged() {
      return this.packet.filter.id === this.current
    }
  },
  methods: {
    open() {
      this.opened = true
    },
    loadConnectionList() {
      serverService.getFilters().then(res => this.items = res.data)
    },
    change() {
      this.$notification.confirm(
          () => {
            this.loading = true
            packetService.changeConnections(this.packet.id, this.current)
                .then(() => {
                  this.$notification.success(this.$t('messages.connection_changed'))
                  this.packet.filter = this.items.find(connection => connection.id === this.current)
                })
                .catch(() => this.$notification.error())
                .finally(() => this.loading = false)
          }
      )
    }
  },
})
</script>

<template>
   <v-dialog width="400" v-model="opened" overlay-opacity="0.9" persistent>
     <v-card class="orderDetails">
       <v-card-title>{{$t('packet.edit_connections')}}<v-spacer/>
         <v-btn icon @click="opened = false">
           <v-icon>mdi-close</v-icon>
         </v-btn>
       </v-card-title>
       <v-card-text>
         <connection-select v-model="current" :type="packet.subscription.type"/>
         <v-row no-gutters class="mt-2">
           <div class="text-center text-h5 white--text">{{price | currencyFilter(true)}}</div>
           <v-spacer />
           <v-btn @click="change" :disabled="notChanged" :loading="loading" rounded color="indigo">{{$t('base.accept')}}</v-btn>
         </v-row>
       </v-card-text>
     </v-card>
   </v-dialog>
</template>

<style scoped>
.orderDetails {
  background: linear-gradient(205deg, #450b6c 0%, #25397b 37%, #000000 74%);
}
</style>